import { toast as customToast } from '@/components/custom-toast'
import { CustomToastProgress } from './custom-toast-progress'

interface Props {
  tier: string
  numberOfReport: number
}

export const showReportLimitToast = ({
  tier,
  numberOfReport,
}: Props) => {
  const title = 'Number of reports exceeded'
  const isAnnual = tier.includes('-annual')
  const tierName = isAnnual ? tier.replace('-annual', ' Annual'): tier

  const message = `You have reached the ${isAnnual ? 'annual' : 'monthly'} limit of ${numberOfReport} reports included in your ${tierName} plan. Upgrade your plan to generate additional reports.`

  return customToast.custom({
    renderLayout: (toastId) => (
      <CustomToastProgress
        toastId={toastId}
        title={title}
        description={message}
      />
    ),
    duration: 100000,
  })
}
